var axios = require('axios')
// 接口地址
var apiHost = 'https://yuan.znstny.cn'
// var apiHost = '/apis'
/**
 * 判断元素类型
 * @param obj
 * @returns {string}
 */
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

/**
 * 参数过滤
 * @param o
 * @returns {*}
 */
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

/**
 * 接口请求
 * @param method	请求类型
 * @param url			请求地址
 * @param params	参数格式：{id:10,name:''}
 * @param handler 处理返回结果的方法
 */
function apiAxios(method, url, params, handler, err) {

  if (params) {
    params = filterNull(params)
  }

  axios({
    headers: {
      stid: window.localStorage.getItem('store_id'),
      token: window.localStorage.getItem('token'),
    },
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: apiHost,
    withCredentials: false,
  }).then(function(res) {
    let data = {};
    if (typeof(res.data) == 'object') {
      data = res.data
    } else {
      data = JSON.parse(res.data)
    }
    handler && handler(data);
  }).catch(function(res) {
    err && err(res);
  })
}

export default {
  get: function(url, params, handler) {
    return apiAxios('GET', url, params, handler)
  },
  post: function(url, params, handler) {
    return apiAxios('POST', url, params, handler)
  },
  put: function(url, params, handler) {
    return apiAxios('PUT', url, params, handler)
  },
  delete: function(url, params, handler) {
    return apiAxios('DELETE', url, params, handler)
  }
}



// WEBPACK FOOTER //
// ./src/request/index.js